import { writable } from "svelte/store";
export const LATEST_ADDED_PRODUCT = writable({});
export const LATEST_EDITED_PRODUCT = writable({});
export const setLatestAddedProduct = (_id) => {
    LATEST_ADDED_PRODUCT.set({
        _id,
        date: new Date()
    });
};
export const setLatestEditedProduct = (_id) => {
    LATEST_EDITED_PRODUCT.set({
        _id,
        date: new Date()
    });
};
